import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

const getMaxLengthSubstring = (text: string | undefined, maxLength = 30): string | undefined =>
  text && text.length > maxLength ? `${text.substring(0, maxLength - 3)}...` : text;

export default [
  {
    label: 'Zpráva',
    field: 'message',
    mapper: text => getMaxLengthSubstring(text),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Cesta k chybě',
    field: 'stackTrace',
    type: ColumnType.TEXT,
    mapper: text => getMaxLengthSubstring(text),
    width: 200
  },
  {
    label: 'Uživatelský agent',
    field: 'userAgent',
    mapper: text => getMaxLengthSubstring(text),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Url adresa',
    field: 'url',
    mapper: text => getMaxLengthSubstring(text),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Id uživatele',
    field: 'userId',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Ip adresa',
    field: 'ip',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Vytvořeno',
    field: 'created',
    type: ColumnType.DATETIME,
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/errors/_errorsColumns.ts